// Il documento con cui si apre lo strumento la prima volta: mostra le tre
// cose che md2pdf aggiunge al markdown — META, ancore, rimandi — invece di
// spiegarle altrove.

export const ESEMPIO = `<? META:title "Un documento di prova" ?>
<? META:subtitle "scritto dentro md2pdf" ?>
<? META:author "PetaBit S.r.l." ?>

# Panoramica §panoramica

Questo è un documento di prova. Il capitolo sulle macchine virtuali è
§vms:chapter-page, e ci si arriva cliccando.

<? Questo è un commento: non finisce nel PDF. ?>

## Le tre aggiunte §aggiunte

| Cosa | Come si scrive |
|---|---|
| commento | \`<? ... ?>\`, anche su più righe |
| metadato | \`<? META:title "…" ?>\` |
| ancora | \`## Titolo §id\` |
| rimando | \`§id\`, \`§id:chapter\`, \`§id:chapter-page\`, \`§id:page\` |

# Macchine virtuali §vms

Un blocco di codice, che nel PDF ha il suo riquadro:

\`\`\`bash
tvirt list-vms --scope /cluster1
\`\`\`

Torna a §panoramica:chapter-page quando vuoi.
`;
